import React from "react";
import { NavBar } from 'antd-mobile'

import { 
    BodyView,
    ListView,
} from "../../factory/ViewUtil";
import { CellCardView } from "../../factory/CellViews";
import { CopyToClipboard } from "../../factory/FactoryUtil";


const MeSecurityViewController = ({goback, navpush, user}) => {
    return(
        <>
             <div className='fixed-nav-bar'>
                <NavBar onBack = {goback}>Security Center</NavBar>
            </div>
            <BodyView style={{paddingTop : '52px'}}>
                <ListView>
                    <CellCardView onClick={()=>{CopyToClipboard(user.email)}} style={{marginTop : '20px'}} extra={user.email || ''}>Email</CellCardView>
                    <CellCardView onClick={()=> {navpush('./password')}}>Login Password</CellCardView>
                    <CellCardView onClick={()=> {navpush('./payment')}}>Payment Password</CellCardView>
                </ListView>
            </BodyView>
        </>
    );
}
export default React.memo(MeSecurityViewController)